import React, { useRef, useState } from 'react';
import './dataLayer.scss';
import { apiQueryWithToken } from '../../common/services/apiBaseUrlConfig';
import { MotifTable } from '@ey-xd/motif-react';
import { TableHeader } from './TableHeader';
import { useNavigate } from "react-router-dom";
import { MotifProgressLoader } from '@ey-xd/motif-react';
import { Stepper } from '../stepper/stepper';
import logger from "../../common/utils/logger";

export const DataLayer = () => {
    const [searchValue, setSearchValue] = useState('');
    const [dataLayerData, setDataLayerData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const navigate = useNavigate();

    const filteredData = Object.values(dataLayerData?.filter((item) => { return item.fileName.toLowerCase().includes(searchValue.toLowerCase()) })
    );

    React.useEffect(() => {
        getData();
        const intervalId = setInterval(getData, 20000);
        return () => clearInterval(intervalId);
    }, []);

    const gridRef = useRef();
    const navigation = useNavigate();

    const onFilterTextBoxChanged = (value) => {
        logger.info('QQ filter', value, gridRef);
        setSearchValue(value);
    };

    const getData = React.useCallback(() => {
        setIsLoading(true);
        apiQueryWithToken.get(`api/fileupload/DataLayer`).then((data) => {
            setDataLayerData(data.data.dataLayerList);
            setIsLoading(false);
        })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    navigate('/');
                    } else{
                      logger.error('An error occurred:', error);
                      setIsLoading(false);
                    }
            });
    })


    const columnDefs = [
        {
            field: 'controlId',
            headerName: 'ID',
            width: 80
        },
        {
            field: 'fileName',
            headerName: 'File Name',
            width: 120
        },
        {
            field: 'fileType',
            headerName: 'File Type',
            width: 120
        },
        {
            field: 'area',
            filter: true,
            headerName: 'Area',
            width:120
          },
        {
            field: 'region',
            filter: true,
            headerName: 'Region',
            width:120
          },
        {
            field: 'country',
            filter: true,
            headerName: 'Country',
            width: 130
        },
        {
            field: 'sector',
            filter: true,
            headerName: 'Sector',
            width: 120
        },
        {
            field: 'subSector',
            filter: true,
            headerName: 'Subsector',
            width: 140
        },
        {
            field: "subSubSector",
            filter: true,
            headerName: "Sub-Sub Sector",
            width: 170,
          },
        {
            field: 'function',
            filter: true,
            headerName: 'Function',
            width: 130
        },
        {
            field: 'marketSize',
            filter: true,
            headerName: 'Revenue Range',
            width: 170
        },
        {
            field: 'dataExtractionStatus',
            cellRenderer: dotCellRenderer,
            headerName: 'Data Extraction Status',
            width: 200
        },
        {
            field: 'rawLayerStatus',
            cellRenderer: dotCellRenderer,
            headerName: 'Raw Layer Status',
            width: 180
        },
        {
            cellRenderer: dotCellRenderer,
            field: 'standardizedLayerStatus',
            headerName: 'Standardized Layer Status',
            width: 200
        },
        {
            field: 'curatedLayerStatus',
            cellRenderer: dotCellRenderer,
            headerName: 'Curated Layer Status',
            width: 190
        },
        {
            field: 'uploadedBy',
            headerName: 'Uploaded By',
            width: 300
        }
    ];

    return (
        <div className='fileUpload-container'>
            <div className='page-title-wrap'>
                <h3>Data Extraction</h3>
            </div>
            <Stepper />
            {
                filteredData && <div className='grid-wrapper'>
                <TableHeader
                    onFilterTextBoxChanged={onFilterTextBoxChanged}
                    searchValue={searchValue}
                    navigation={navigation}
                />
                <div className='grid-container'>
                    <div className={'ag-theme-quartz grid-container-inner'}>
                        {
                            isLoading ? <MotifProgressLoader
                                show
                                variant="default"
                            /> : <MotifTable
                                columnDefs={columnDefs}
                                description='Descriptive text that describes your page or content.'
                                name='Default'
                                pagination
                                paginationPageSize={10}
                                paginationPageSizeSelector={[3, 4, 5]}
                                rowData={filteredData}
                                zebra={false}
                            />
                        }
                    </div>
                </div>
            </div>
            }
        </div>
    );
};

const dotCellRenderer = ({ value }) => {

    const showStatus = value?.replace(/\s/g, '').toLowerCase();
    return (
        <div
            className={`motif-dot ${showStatus === 'inprogress' && 'motif-dot-left'} ${(showStatus === 'success' || showStatus === 'completed') && 'motif-dot-success'
                } ${showStatus === 'failed' && 'motif-dot-error'} ${showStatus === 'inprogress' && 'motif-dot-warning'
                }`}
        >
            <span className='motif-dot-text'>{value}</span>
        </div>
    );
};
